<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="d-inline-flex">
        <h1 class="h2">Convênios</h1>

        <hr class="vertical-bar" />
      </div>

      <b-form-input
        autofocus
        v-on:keyup.enter="search"
        v-model="viewData.search"
        placeholder="Digite um termo e pressione enter para buscar"
        style="max-width: 80%;"
      ></b-form-input>

      <div class="btn-toolbar mb-2 mb-md-0">
        <div class="btn-group mx-2">
          <BaseButtonComponent to="/covenant/new" variant="primary-action">
            Novo
          </BaseButtonComponent>
        </div>
      </div>
    </div>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading"
    >
      <v-table :fixedColumns="false">
        <thead>
          <tr>
            <td>Convênio</td>
            <td>Registro</td>
            <td>Tipo</td>
            <td>Opções</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.name }}</td>
            <td>{{ item.register }}</td>
            <td>{{ item.type }}</td>
            <td style="text-align:right">
              <BaseButtonComponent
                :to="`/covenant/edit/${item.id}`"
                size="sm"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </v-table>
    </div>
    <empty-list
      v-else-if="!viewData.loading && state.list.length === 0"
    ></empty-list>
  </main>
</template>

<script>
import { Api } from '../../vue/api';
import helpers from '../../vue/helpers';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'covenant-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
      },
      viewData: {
        loading: false,
        search: '',
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }

    await this.getAll();
  },
  methods: {
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/covenant' + helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state.list = { ...result.model };

        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    BaseButtonComponent,
  },
};
</script>
